import * as React from 'react';
import { redirectGoogleLogin } from '../../../utils/providerLogin';
import { GoogleGSvg } from './GoogleGSvg';
import { BtnBrand, BtnContent, BtnIcon, BtnPrefix, SocialBtn } from '../SocialIconButton/styles';

function GoogleRedirectButton({ prefix, overlay, loginHint }) {
  const onClick = () => redirectGoogleLogin(loginHint);

  if (overlay) {
    return (
      <SocialBtn
        type="button"
        onClick={onClick}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          opacity: 0.001,
          zIndex: 2,
          border: 'none',
          background: 'transparent',
        }}
        aria-label="Entrar com Google"
      />
    );
  }

  return (
    <SocialBtn type="button" onClick={onClick}>
      <BtnContent>
        <BtnPrefix>{prefix}</BtnPrefix>
        <BtnBrand color="#EA4335">Google</BtnBrand>
      </BtnContent>
      <BtnIcon>
        <GoogleGSvg />
      </BtnIcon>
    </SocialBtn>
  );
}

export function GoogleSignInButton({ prefix = 'Entrar com', overlay = false, loginHint }) {
  return <GoogleRedirectButton prefix={prefix} overlay={overlay} loginHint={loginHint} />;
}
